import {
    Patient,
    MedicationsEntity,
    DiagnosisEntityOrSymptomsEntity,
} from '../store/types/prescription';
import { PREDICT_NEXT_MEDICINES } from './constants';
import { Drug } from './fetchMatchingDrugsLabTests';
import fetchWithRefresh from './fetchWithRefresh';

type RequestBody = {
    prid: string;
    current_rx: {
        patient: Patient;
        date: string;
        medications?: MedicationsEntity[];
        symptoms?: DiagnosisEntityOrSymptomsEntity[];
        diagnosis?: DiagnosisEntityOrSymptomsEntity[];
    };
};

type Response = {
    drugs?: Drug[];
};

export default (body: RequestBody, timeout: number): Promise<Response> => {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
            reject(new Error('Request timed out'));
        }, timeout);

        fetchWithRefresh(PREDICT_NEXT_MEDICINES, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: { 'Content-Type': 'application/json' },
            mode: 'cors',
            credentials: 'include',
        }).then((res) => {
            clearTimeout(timer); // Clear the timeout on success
            if (res.status === 200) {
                resolve(res.json());
            } else {
                reject(new Error('Failed to fetch doc assist hash'));
            }
        });
    });
};
